import _toConsumableArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import LAB_CONSTANTS from './lab-constants.js';
import { unpack } from '../../utils/index.js';
var rgb2lab = function rgb2lab() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var _unpack = unpack(args, 'rgb'),
    _unpack2 = _toArray(_unpack),
    r = _unpack2[0],
    g = _unpack2[1],
    b = _unpack2[2],
    rest = _unpack2.slice(3);
  var _rgb2xyz = rgb2xyz(r, g, b),
    _rgb2xyz2 = _slicedToArray(_rgb2xyz, 3),
    x = _rgb2xyz2[0],
    y = _rgb2xyz2[1],
    z = _rgb2xyz2[2];
  var _xyz2lab = xyz2lab(x, y, z),
    _xyz2lab2 = _slicedToArray(_xyz2lab, 3),
    L = _xyz2lab2[0],
    a = _xyz2lab2[1],
    b_ = _xyz2lab2[2];
  return [L, a, b_].concat(_toConsumableArray(rest.length > 0 && rest[0] < 1 ? [rest[0]] : []));
};
function xyz2lab(x, y, z) {
  var Xn = LAB_CONSTANTS.Xn,
    Yn = LAB_CONSTANTS.Yn,
    Zn = LAB_CONSTANTS.Zn,
    kE = LAB_CONSTANTS.kE,
    kK = LAB_CONSTANTS.kK;
  var xr = x / Xn;
  var yr = y / Yn;
  var zr = z / Zn;
  var fx = xr > kE ? Math.pow(xr, 1.0 / 3.0) : (kK * xr + 16.0) / 116.0;
  var fy = yr > kE ? Math.pow(yr, 1.0 / 3.0) : (kK * yr + 16.0) / 116.0;
  var fz = zr > kE ? Math.pow(zr, 1.0 / 3.0) : (kK * zr + 16.0) / 116.0;
  return [116.0 * fy - 16.0, 500.0 * (fx - fy), 200.0 * (fy - fz)];
}
function gammaAdjustSRGB(companded) {
  var sign = Math.sign(companded);
  companded = Math.abs(companded);
  var linear = companded <= 0.04045 ? companded / 12.92 : Math.pow((companded + 0.055) / 1.055, 2.4);
  return linear * sign;
}
var rgb2xyz = function rgb2xyz(r, g, b) {
  // normalize and gamma adjust
  r = gammaAdjustSRGB(r / 255);
  g = gammaAdjustSRGB(g / 255);
  b = gammaAdjustSRGB(b / 255);
  var MtxRGB2XYZ = LAB_CONSTANTS.MtxRGB2XYZ,
    MtxAdaptMa = LAB_CONSTANTS.MtxAdaptMa,
    MtxAdaptMaI = LAB_CONSTANTS.MtxAdaptMaI,
    Xn = LAB_CONSTANTS.Xn,
    Yn = LAB_CONSTANTS.Yn,
    Zn = LAB_CONSTANTS.Zn,
    As = LAB_CONSTANTS.As,
    Bs = LAB_CONSTANTS.Bs,
    Cs = LAB_CONSTANTS.Cs;
  var x = r * MtxRGB2XYZ.m00 + g * MtxRGB2XYZ.m10 + b * MtxRGB2XYZ.m20;
  var y = r * MtxRGB2XYZ.m01 + g * MtxRGB2XYZ.m11 + b * MtxRGB2XYZ.m21;
  var z = r * MtxRGB2XYZ.m02 + g * MtxRGB2XYZ.m12 + b * MtxRGB2XYZ.m22;
  var Ad = Xn * MtxAdaptMa.m00 + Yn * MtxAdaptMa.m10 + Zn * MtxAdaptMa.m20;
  var Bd = Xn * MtxAdaptMa.m01 + Yn * MtxAdaptMa.m11 + Zn * MtxAdaptMa.m21;
  var Cd = Xn * MtxAdaptMa.m02 + Yn * MtxAdaptMa.m12 + Zn * MtxAdaptMa.m22;
  var X = x * MtxAdaptMa.m00 + y * MtxAdaptMa.m10 + z * MtxAdaptMa.m20;
  var Y = x * MtxAdaptMa.m01 + y * MtxAdaptMa.m11 + z * MtxAdaptMa.m21;
  var Z = x * MtxAdaptMa.m02 + y * MtxAdaptMa.m12 + z * MtxAdaptMa.m22;
  X *= Ad / As;
  Y *= Bd / Bs;
  Z *= Cd / Cs;
  x = X * MtxAdaptMaI.m00 + Y * MtxAdaptMaI.m10 + Z * MtxAdaptMaI.m20;
  y = X * MtxAdaptMaI.m01 + Y * MtxAdaptMaI.m11 + Z * MtxAdaptMaI.m21;
  z = X * MtxAdaptMaI.m02 + Y * MtxAdaptMaI.m12 + Z * MtxAdaptMaI.m22;
  return [x, y, z];
};
export default rgb2lab;
export { rgb2xyz };